'use client';

import { Typography, TypographyProps } from '@mui/material';

import { styled } from '../../styles';

export const DataDetailsMobileDrawerCoinHeaderContainer = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
  }),
);

export const DataDetailsMobileDrawerCoinHeaderNameContainer = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(2),
  }),
);

export const ShortName = styled(Typography)<TypographyProps>(() => ({
  marginBottom: 1,
}));
